
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logistic",
      function () {
        return require("private-next-pages/logistic/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logistic"])
      });
    }
  